import React from 'react';

import AccountBreadcrumbs from 'components/account/AccountBreadcrumbs';
import CollectionListCard from 'components/account/Collections/CollectionListCard';
import DeleteCollectionModal from 'components/account/Collections/DeleteCollectionModal';
import NewCollectionModal from 'components/account/Collections/NewCollectionModal';
import ShareCollectionModal from 'components/account/Collections/ShareCollectionModal';
import MartyLink from 'components/common/MartyLink';
import SiteAwareMetadata from 'components/SiteAwareMetadata';
import { HEART_DEFAULT_LIST_ID } from 'constants/apis';
import { INFLUENCER_HUB_PAGE } from 'constants/influencerPages';
import AccountHeader from 'containers/account/AccountHeader';

import css from 'styles/containers/account/collections.scss';

export const Favorites = ({
  testId,
  currentlyFocusedListId,
  isInfluencerAccount,
  collectionWithItems,
  collectionNextPageToken,
  showNewCollectionModal,
  onCancelNewCollection,
  onSaveNewCollection,
  showDeleteCollectionModal,
  showShareCollectionModal,
  onShareCollection,
  onDeleteCollection,
  onStartNewCollection,
  loadMore,
  onOpenShareModal,
  onOpenDeleteModal,
  heartsStyleIds
}) => (
  <SiteAwareMetadata>
    <div className={css.collections}>
      <NewCollectionModal showNewCollectionModal={showNewCollectionModal} onCancelModal={onCancelNewCollection} onDoneModal={onSaveNewCollection} />
      <DeleteCollectionModal
        showDeleteCollectionModal={showDeleteCollectionModal}
        listId={currentlyFocusedListId}
        onDoneModal={onDeleteCollection}
      />
      <ShareCollectionModal showShareCollectionModal={showShareCollectionModal} listId={currentlyFocusedListId} onDoneModal={onShareCollection} />
      <AccountBreadcrumbs currentText="Favorites" />
      <div className={css.headingContainer}>
        <div className={css.accountHeader}>
          <AccountHeader title="Favorites" showFirstName={false} showCustomerEmail={false} />
        </div>
        <button className={css.newCollection} type="button" onClick={onStartNewCollection} data-test-id={testId('newCollectionButton')}>
          Create New List
        </button>
      </div>
      <section className={css.collectionListContainer} key={`${collectionWithItems.length}-collectionContainer`}>
        {collectionWithItems?.map(collection => {
          const { listId, hearts, name, metadata = {} } = collection;
          let { itemCount } = collection;
          const { public: isPublic } = metadata;
          if (isInfluencerAccount && heartsStyleIds && listId === HEART_DEFAULT_LIST_ID) {
            // TODO it will be removed once migration of heart list is done for Vrsnl
            itemCount = heartsStyleIds.length;
          }
          if (!isPublic || listId === HEART_DEFAULT_LIST_ID) {
            return (
              <CollectionListCard
                key={listId}
                listId={listId}
                hearts={hearts}
                name={name}
                itemCount={itemCount}
                onOpenShareModal={onOpenShareModal}
                onOpenDeleteModal={onOpenDeleteModal}
              />
            );
          }
        })}
      </section>
      {!!collectionNextPageToken && (
        <button type="button" className={css.loadMore} ref={loadMore}>
          More
        </button>
      )}
      {isInfluencerAccount && (
        <section className={css.linktoInfluencerHub}>
          Looking for collections from your influencer program? Go to
          <MartyLink className={css.linkOfInfluencerHub} to={INFLUENCER_HUB_PAGE}>
            {' '}
            Influencer Hub
          </MartyLink>
        </section>
      )}
    </div>
  </SiteAwareMetadata>
);
